import React from 'react'

const TranslateSelect = () => {
  return (
    <div>TranslateSelect</div>
  )
}

export default TranslateSelect
